var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardUnblock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6/\xD0\x9A\xD0\xB0\xD1\x80\xD1\x82\xD0\xB0/\xD0\x9A\xD0\xB0\xD1\x80\xD1\x82\xD0\xB0/\xD0\xA0\xD0\xB0\xD0\xB7\xD0\xBB\xD0\xBE\xD0\xBA\xD0\xB8\xD1\x80\xD0\xBE\xD0\xB2\xD0\xBA\xD0\xB0 \xD0\xBA\xD0\xB0\xD1\x80\xD1\x82\xD1\x8B"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1 12H8.33333M6.5 8.33334V4.66667C6.5 2.64083 8.14083 1 10.1667 1C12.1925 1 13.8333 2.64083 13.8333 4.66667V8.33334M23 19.3333V21.1667C23 22.1796 22.1796 23 21.1667 23H2.83333C1.82042 23 1 22.1796 1 21.1667V8.33332C1 7.3204 1.82042 6.49999 2.83333 6.49999C2.83333 6.49999 3.03404 6.49999 3.75 6.49999M12 8.33336H23V15.6667H12V8.33336Z",
    stroke: "#34C34D",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardUnblock);
export default __webpack_public_path__ + "static/media/card-unblock.33c6136f87d91445413b8d87dd3b5a20.svg";
export { ForwardRef as ReactComponent };